module.exports = __webpack_public_path__ + "assets/images/premium-features/multiple-alarms-f139c2.svg";